import React from "react";

import { API_URL } from "../../constant";
import { App } from "../../firebase";

import { useHistory, useParams } from "react-router-dom";
import BigTitle from "../BigTitle";
import { Row } from "../FooterStyles";

function PayForm() {
  const { id } = useParams();
  const [loading, setLading] = React.useState(false);
  const db = App.firestore();
  const history = useHistory();
  const [checked, setChecked] = React.useState(false);
  const [openCards, setOpenCards] = React.useState(false);
  const [allCards, setCards] = React.useState([]);
  const [loadingCard, setLoadingCard] = React.useState("");
  const prestations = history.location.state.prestations;
  const professionnel = history.location.state.professionnel;
  const [stripeId, setCustomerId] = React.useState("");
  const [payCardId, setPaycardId] = React.useState(null);
  const [userId, setUserId] = React.useState(null);
  const [size, setSize] = React.useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const getCardsUser = async (customerId) => {
    setLoadingCard(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      customerId: customerId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "list-method-card", requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.cards) {
          // console.log(data.cards.length);
          setCards(data.cards);
        } else {
          setCards([]);
        }
        setLoadingCard(false);
      })
      .catch((err) => {
        setLoadingCard(false);
        console.log(err);
        alert("Une erreur s'est produite");
      });
  };
  React.useEffect(() => {
    App.auth().onAuthStateChanged((u) => {
      if (u) {
        setUserId(u.uid);
        getUserInfos(u.uid, (customerStripeId) => {
          // console.log("customerStripeId", customerStripeId);
          setCustomerId(customerStripeId);
          if (professionnel.acompte == null || professionnel.acompte == 0) {
            setTimeout(() => {
              confirmDirectly(u);
            }, 300);
          }
        });
      } else {
        setCustomerId(null);
        setUserId(null);
      }
    });
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getUserInfos = (uid, com) => {
    var docRef = db.collection("users").doc(uid);

    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          const { customerStripeId } = doc.data();
          com(customerStripeId);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };
  const addCardIt = (target, cusId = null) => {
    fetch(API_URL + "payment-method-card", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        number: target.cardnumber.value + "",
        exp_month: target.expmonth.value,
        exp_year: target.expyear.value,
        cvc: target.cvv.value,
        customerId: cusId,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.id) {
          // alert("Carte ajoutée");
          payWith(data.id);
        } else {
          console.log(data);
          setLading(false);
          alert("Une erreur s'est produite");
        }
      })
      .catch((err) => {
        console.log(err);
        setLading(false);
        alert("Carte invalide");
      });
  };

  // STEP 2: make the payment after filling the form properly
  const makePayment = async (e) => {
    e.preventDefault();
    setLading(true);

    if (checked) {
      getUserInfos(App.auth().currentUser.uid, (customerId) => {
        addCardIt(e.target, customerId);
      });
    } else {
      addCardIt(e.target);
    }
  };
  const calPrice = (withfrais) => {
    var priceT = 0;
    // console.log("prestations", prestations);
    prestations.forEach((p) => {
      priceT += p.price;
    });
    var t = priceT * (professionnel.acompte / 100);
    if (withfrais) {
      t += 100;
    }
    return (t / 100).toFixed(2);
  };

  const confirmDirectly = (user) => {
    fetch(API_URL + "pay", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: user.uid,
        cartId: id,
        noaccompte: true,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          history.push("/booking-recap/" + id);
        } else {
          alert("Une erreur est survenu, réessayez plus tard, merci");
        }
      })
      .catch((erro) => {
        alert("Une erreur est survenu, réessayez plus tard, merci");
        window.location.reload();
      });
  };

  const payWith = (cardId) => {
    setPaycardId(cardId);

    fetch(API_URL + "pay", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cardId: cardId,
        userId: userId,
        cartId: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          var link;
          //afficher le 3D secure
          if (data.payment.next_action) {
            let next_action = data.payment.next_action;
            if (next_action.use_stripe_sdk) {
              link = next_action.use_stripe_sdk.stripe_js;
              // window.open(next_action.use_stripe_sdk.stripe_js, "_newtab");

              const strWindowFeatures =
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes";
              window.open(
                next_action.use_stripe_sdk.stripe_js,
                "CNN_WindowName",
                strWindowFeatures
              );
            }
          }
          // redirection vers la page de validation
          setTimeout(() => {
            history.push({
              pathname: "/booking-recap/" + id + "?pay=checking",
              state: {
                next_action: link,
              },
            });
            setPaycardId(null);
          }, 1500);
        } else {
          setPaycardId(null);
          alert("Une erreur s'est produite");
        }
      })
      .catch((err) => {
        setPaycardId(null);
        console.log(err);
        alert("Une erreur s'est produite");
      });
  };

  if (professionnel.acompte == null || professionnel.acompte == 0) {
    return (
      <div
        style={{
          margin: "auto",
          padding: "60px 0px",
          width: 55,
        }}
      >
        <div class="loader" />
      </div>
    );
  }

  return (
    <>
      <BigTitle title="Paiement" />
      <div class="row" style={{ maxWidth: 784, margin: "60px auto" }}>
        <div class="col-75">
          <div class="container">
            <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
              Mes informations de paiement
            </div>
            <div className="content-bloc" style={{ width: "100%" }}>
              <div className="content-sha">
                {!openCards ? (
                  <form onSubmit={makePayment}>
                    <div
                      class="row"
                      style={{ flexDirection: size.width <= 428 && "column" }}
                    >
                      <div class="col-50">
                        <input
                          class="roboto-normal-16px"
                          style={{ padding: "10px", border: "none" }}
                          type="number"
                          id="ccnum"
                          name="cardnumber"
                          placeholder="N° de carte"
                          required
                          autoFocus={true}
                        />

                        <div
                          style={{
                            marginBottom: 9,
                            backgroundColor: "#BFBFBF",
                            width: "100%",
                            height: 1,
                          }}
                        />
                      </div>

                      <div class="col-50">
                        <input
                          className="roboto-normal-16px"
                          style={{
                            padding: "10px",
                            border: "none",
                            width: "100%",
                          }}
                          type="number"
                          id="expmonth"
                          name="expmonth"
                          min={1}
                          max={12}
                          placeholder="Mois d'éxpiration (1 - 12)"
                          required
                        />
                        <div
                          style={{
                            marginBottom: 9,
                            backgroundColor: "#BFBFBF",
                            width: "100%",
                            height: 1,
                          }}
                        />
                      </div>
                    </div>

                    <div
                      class="row"
                      style={{ flexDirection: size.width <= 428 && "column" }}
                    >
                      <div class="col-50">
                        {/* <label for="expyear">Année d'éxpiration</label> */}
                        <input
                          className="roboto-normal-16px"
                          style={{ padding: "10px", border: "none" }}
                          type="number"
                          id="expyear"
                          name="expyear"
                          min={2022}
                          placeholder="Année d'éxpiration (2024)"
                          required
                        />
                        <div
                          style={{
                            marginBottom: 9,
                            backgroundColor: "#BFBFBF",
                            width: "100%",
                            height: 1,
                          }}
                        />
                      </div>
                      <div class="col-50">
                        <input
                          className="roboto-normal-16px"
                          style={{ padding: "10px", border: "none" }}
                          type="text"
                          id="cvv"
                          name="cvv"
                          placeholder="CVV"
                          required
                        />
                        <div
                          style={{
                            marginBottom: 9,
                            backgroundColor: "#BFBFBF",
                            width: "100%",
                            height: 1,
                          }}
                        />
                      </div>
                    </div>
                    {loading ? (
                      <div
                        style={{
                          margin: "auto",
                          padding: "60px 0px",
                          width: 55,
                        }}
                      >
                        <div class="loader" />
                      </div>
                    ) : (
                      <>
                        <div>
                          <p
                            className="raleway-medium-eerie-black-16px"
                            style={{ marginTop: 20 }}
                          >
                            Sous-total :{" "}
                            {prestations.length > 0 && calPrice(false)} €
                          </p>
                          <p
                            className="raleway-medium-eerie-black-16px"
                            style={{ marginTop: 10 }}
                          >
                            Frais de services : 1.00 €
                          </p>
                        </div>
                        <div
                          class="row"
                          style={{
                            flexDirection: size.width <= 428 && "column",
                          }}
                        >
                          {/* // <div style={{ display: "flex", alignContent: "center" }}> */}
                          <div class="col-50">
                            <input
                              type="submit"
                              class="bouton-plein border-1px-dove-gray sinscrire raleway-bold-eerie-black-14px btn"
                              style={{
                                height: 55,
                                marginTop: "20px",
                                color: "white",
                                maxWidth: 300,
                                border: "none",
                              }}
                              value={
                                "Payer un acompte de  " + calPrice(true) + " €"
                              }
                            />
                          </div>
                          <div class="col-50">
                            <a
                              href
                              onClick={() => {
                                setOpenCards(!openCards);
                                if (
                                  !openCards &&
                                  stripeId &&
                                  allCards.length == 0
                                ) {
                                  getCardsUser(stripeId);
                                }
                              }}
                            >
                              <p
                                className="raleway-medium-eerie-black-15px"
                                style={{
                                  paddingTop: size.width > 428 ? 40 : 20,
                                }}
                              >
                                <u>Utiliser une carte enregistrée</u>
                              </p>
                            </a>
                          </div>
                          <div
                            class="col-50"
                            style={{ marginTop: 19, display: "flex" }}
                          >
                            <input
                              type={"checkbox"}
                              id={"cgu"}
                              name={"cgu"}
                              checked={checked}
                              onChange={(e) => setChecked(!checked)}
                            />
                            <label
                              for="cgu"
                              style={{ marginLeft: 10 }}
                              className="raleway-medium-eerie-black-15px"
                            >
                              Mémoriser mon moyen de paiement
                            </label>
                          </div>
                        </div>
                        <div
                          class="row"
                          style={{
                            flexDirection: size.width <= 428 && "column",
                            paddingBottom: 17,
                          }}
                        >
                          <div class="col-25">
                            <a href>
                              <p
                                className="raleway-medium-eerie-black-12px"
                                style={{
                                  paddingTop: 40,
                                  color: "#707070",
                                }}
                              >
                                <u>
                                  <a href="/privacy" target={"_blank"}>
                                    Politique de confidentialité
                                  </a>
                                </u>
                              </p>
                            </a>
                          </div>
                          <div class="col-25">
                            <a href>
                              <p
                                className="raleway-medium-eerie-black-12px"
                                style={{
                                  paddingTop: size.width > 428 && 40,
                                  color: "#707070",
                                }}
                              >
                                <u>
                                  <a href="/refund" target={"_blank"}>
                                    Politique de remboursement
                                  </a>
                                </u>
                              </p>
                            </a>
                          </div>
                          <div class="col-25">
                            <a href>
                              <p
                                className="raleway-medium-eerie-black-12px"
                                style={{
                                  paddingTop: size.width > 428 && 40,
                                  color: "#707070",
                                }}
                              >
                                <u>
                                  <a href="/cgv" target={"_blank"}>
                                    CGV
                                  </a>
                                </u>
                              </p>
                            </a>
                          </div>
                        </div>
                      </>
                    )}
                  </form>
                ) : (
                  <>
                    <Row>
                      <p className="subtitle" style={{ paddingBottom: 20 }}>
                        {allCards &&
                          allCards.length == 0 &&
                          !loadingCard &&
                          "Vous n'avez actuellement aucune carte"}
                        {loadingCard && "Chargement..."}
                      </p>
                    </Row>
                    <div>
                      {allCards && allCards.length != 0 && (
                        <>
                          <div
                            style={{
                              marginBottom: 20,
                              textAlign: "center",
                              width: "100%",
                            }}
                            class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                          >
                            Payer un acompte de {calPrice(true)} €
                          </div>
                          <div>
                            <p
                              className="raleway-medium-eerie-black-16px"
                              style={{ marginTop: 20 }}
                            >
                              Sous-total : {calPrice(false)} €
                            </p>
                            <p
                              className="raleway-medium-eerie-black-16px"
                              style={{ marginTop: 10, marginBottom: 20 }}
                            >
                              Frais de services : 1.00 €
                            </p>
                          </div>
                        </>
                      )}
                      {allCards.map((a) => {
                        if (payCardId === null) {
                          return (
                            <div
                              className="col-50"
                              style={{
                                paddingRight: size.width > 800 ? 37 : 15,
                                marginBottom: 15,
                              }}
                            >
                              {/* {console.log(a)} */}
                              {/* <img>{a.card.brand}</img> */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    // backgroundColor: "red",
                                    width: 27.34,
                                    height: 21.27,
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    alt=""
                                    src={"/" + a.card.brand + ".png"}
                                    style={{
                                      maxWidth: 27.34,
                                      height: 21.27,
                                    }}
                                  />
                                </div>
                                <span className="roboto-normal-eerie-black-20px">
                                  **** **** **** {a.card.last4}
                                </span>

                                {size.width > 800 && (
                                  <a
                                    onClick={() => {
                                      payWith(a.id);
                                    }}
                                    href
                                  >
                                    <div
                                      class=" border-2px-eerie-black"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: 10,
                                        display: "flex",
                                        height: 35,
                                        // width: 196,
                                        padding: "0px 20px",
                                        marginLeft: 40,
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <div
                                        class="sinscrire raleway-bold-eerie-black-12px"
                                        style={{}}
                                      >
                                        Utiliser ce moyen de paiement
                                      </div>
                                    </div>
                                  </a>
                                )}
                              </div>
                              {size.width <= 800 && (
                                <a
                                  onClick={() => {
                                    payWith(a.id);
                                  }}
                                  href
                                >
                                  <div
                                    class=" border-2px-eerie-black"
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: 10,
                                      display: "flex",
                                      height: 35,
                                      marginTop: 3,
                                      marginBottom: 3,
                                      padding: "0px 20px",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      class="sinscrire raleway-bold-eerie-black-12px"
                                      style={{}}
                                    >
                                      Utiliser ce moyen de paiement
                                    </div>
                                  </div>
                                </a>
                              )}
                              <div
                                style={{
                                  marginTop: 9,
                                  backgroundColor: "#BFBFBF",
                                  width: "100%",
                                  height: 1,
                                }}
                              />
                            </div>
                          );
                        } else if (payCardId === a.id) {
                          return (
                            <div
                              className="col-50"
                              style={{
                                paddingRight: 37,
                                marginBottom: 15,
                                marginTop: 30,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  style={{
                                    width: 27.34,
                                    height: 21.27,
                                    marginRight: 10,
                                  }}
                                >
                                  <img
                                    alt=""
                                    src={"/" + a.card.brand + ".png"}
                                    style={{
                                      maxWidth: 27.34,
                                      height: 21.27,
                                    }}
                                  />
                                </div>
                                <span className="roboto-normal-eerie-black-20px">
                                  **** **** **** {a.card.last4}
                                </span>

                                {size.width > 800 && (
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: 10,
                                      display: "flex",
                                      height: 35,
                                      // width: 196,
                                      padding: "0px 20px",
                                      marginLeft: 40,
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <div
                                      class="sinscrire raleway-bold-eerie-black-12px"
                                      style={{}}
                                    >
                                      Paiement en cours ....
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  margin: "auto",
                                  padding: "60px 0px",
                                  width: 55,
                                }}
                              >
                                <div class="loader" />
                              </div>
                            </div>
                          );
                        }
                      })}

                      {payCardId === null && (
                        <div class="col-50">
                          <a
                            href
                            onClick={() => {
                              setOpenCards(!openCards);
                              if (
                                !openCards &&
                                stripeId &&
                                allCards.length == 0
                              ) {
                                getCardsUser(stripeId);
                              }
                            }}
                          >
                            <p
                              className="raleway-medium-eerie-black-15px"
                              style={{
                                paddingTop: size.width > 428 ? 40 : 20,
                              }}
                            >
                              <u>Ne pas utiliser une carte enregistrée</u>
                            </p>
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <p className="raleway-normal-silver-13px ">
              Frais de services inclus : 1.00€
              <br />
              <br />
              Vos données personnelles seront utilisées pour le traitement de
              votre carte, vous accompagner au cours de votre visite du site
              web, et pour d’autres raisons décrites dans notre politique de
              confidentialité.
              <br />
              <br />
              Notre partenaire Stripe réalise le traitement et l'enregistrement
              des données bancaires onFleek.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PayForm;
